module.exports = __webpack_public_path__ + "media/images/member_gift-7b264bb08b5e9bb0d3c04408bcc16d4f.svg";